<template>
  <div style="display: flex; flex-direction: column; margin: 0 auto; padding: 36px 0;">
    <Loader v-if="infoLoading" />
    <template v-else>
      <span v-if="route.path.toLowerCase().includes('moduleeditor')"  @click.stop="goBackToCourseStructure()" class="goBack"><i class="material-icons-outlined">arrow_back</i> {{ $t('masterCoursesMain.GO_BACK_TO_COURSE_STRUCTURE') }}</span>
      <span v-else @click.stop="goToTable" class="goBack"><i class="material-icons-outlined">arrow_back</i> {{ $t('masterCoursesMain.GO_BACK_TO_COURSE_LIST') }}</span>
      <router-view :data="info" :creationOptions="creationOptions" @changeData="changeData" />
    </template>

    <Modal :isOpen="exitWithoutSaveModal" @close="exitWithoutSaveModal = false">
      <div class="exitWithoutSaveModal">
        <h2 class="exitWithoutSaveModal__title">{{ $t('masterCoursesMain.CONFIRM_EXIT_EDITING') }}</h2>
        <span class="exitWithoutSaveModal__content">{{ $t('masterCoursesMain.CHANGES_WILL_NOT_BE_SAVED') }}</span>
        <div class="exitWithoutSaveModal__buttons">
          <button class="exitWithoutSaveModal__cancel" @click="exitWithoutSaveModal = false">{{ $t('global.CANCEL') }}</button>
          <button class="exitWithoutSaveModal__exit" @click="router.push('/contents/mastercourses')">{{ $t('masterCoursesMain.EXIT_EDITING') }}</button>
        </div>
      </div>
    </Modal>

  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex';
import Loader from '@/components/Loader.vue';
import Modal from '../../../components/Modal.vue';
import { useI18n } from 'vue-i18n';

export default {
  components: {
    Loader,
    Modal
},
  setup() {
    const route = useRoute()
    const router = useRouter()
    const infoLoading = ref(true)
    const info = ref()
    const store = useStore()
    const creationOptions = ref()
    const exitWithoutSaveModal = ref()
    const user = computed(() => store.getters.manageUser_user);
    const { t } = useI18n();


    const goToTable = () => {
      if (route.path.toLowerCase().includes('copy') || route.path.toLowerCase().includes('edit')) {
        exitWithoutSaveModal.value = true
      }
      router.push('/contents/mastercourses')
    }

    const goBackToCourseStructure = () => {
      // back then reload data
      router.push(`/contents/mastercourses/${route.params.courseCfgId}/structure`).then(() => {
        getInfo()
      })
    }

    const getInfo = async () => {
      try {
        infoLoading.value = true
        const { data } = await store.dispatch('courses_cfginfo', route.params.courseCfgId)
        const { data: options } = await store.dispatch('courses_cfgcreationoptions')
        creationOptions.value = options
        info.value = data
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('masterCoursesMain.ERROR_LOADING_INFORMATION') })
      } finally {
        infoLoading.value = false
      }
    }

    const changeData = (data) => {
      console.log(data)
      info.value = data
    }

    onMounted(() => {
      if(!user.value.permissions.includes('ACCESO_CONTENIDO')) router.push('/')
      getInfo()
    })

    return {
      info,
      infoLoading,
      creationOptions,
      router,
      route,
      exitWithoutSaveModal,
      t,

      changeData,
      getInfo,
      goToTable,
      goBackToCourseStructure
    }
  }
    
  }
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
.goBack{
  color: $green;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  padding-left: 100px;
  cursor: pointer;
  .material-icons-outlined{
    font-size: 18px;
  }
}

.exitWithoutSaveModal{
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 18px;
  padding: 24px;
  &__title{
    font-weight: 600;
    font-size: 18px;
  }
  &__content{
    font-size: 18px;
    font-weight: 400;
  }
  &__buttons{
    display: flex;
    align-items: center;
    gap: 16px;
  }
  &__cancel{
    border: none;
    color: #000;
    font-weight: 600;
    font-size: 16px;
  }
  &__exit{
    padding: 12px 0;
    width: 182px;
    background-color: #F57055;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    border-radius: 44px;
  }
}
</style>